module.exports = __webpack_public_path__ + "img/1.aa994e2b.png";